







import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'TeaserText',
  props: { blok: { type: Object } },
});
